import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Typography, Button, Card, CardContent, CardActions, Icon } from '@material-ui/core';

class NotFoundScreen extends Component {
    render() {
        return (
            <Card>
                <CardContent>
                    <Typography variant="h5"><Icon style={{ marginRight: 10 }}>info</Icon> Oops, this page was not found.</Typography>
                    <Typography variant="body1">If this route is correct, please contact the Administrator.</Typography>

                </CardContent>
                <CardActions >
                    <Link to="/" style={{ textDecoration: 'none' }}>
                        <Button variant="contained" color="secondary">
                            <Icon style={{ marginRight: 10 }}>arrow_back</Icon> Go to Home Screen
                        </Button>
                    </Link>
                </CardActions>
            </Card>
        )
    }
}

export default NotFoundScreen;